module.exports = __webpack_public_path__ + "fonts/trust_sans_bold_it-webfont.47f2a438.woff2";